<template>
  <div class="page-layout">
      <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
